import thirPartPayBg from "../../../assets/image/store/thridPayBg.jpg"; 
import whiteProductSwitchBtn from "../../../assets/image/store/product-change.png"; 
import bindIcon from "../../../assets/image/icons/bind-icon.png"; 
import showdetail from "../../../assets/image/icons/show-detail.png"; 
import userIcon from "../../../assets/image/icons/user-icon.png"; 
import tokenIcon from "../../../assets/image/icons/token-icon.png"; 
import dmaIcon from "../../../assets/image/icons/dma-icon.png"; 
import officialPayIcon from "../../../assets/image/icons/fund-terms.png"; 
import ellipsisIcon from "../../../assets/image/icons/feedback-icon.png"; 
import textIcon from "../../../assets/image/icons/text-icon.png"; 
import accountFollowIcon from "../../../assets/image/icons/account-follow.png"; 
import exchangeIcon from "../../../assets/image/icons/exchange-icon.png"; 
import rewardIcon from "../../../assets/image/icons/reward-ico.png"; 
import fundTermsIcon from "../../../assets/image/icons/fund-terms.png"; 
import deleteIcon from "../../../assets/image/icons/delete.png"; 
import survey from "../../../assets/image/icons/survey.png"; 
import settingIcon from "../../../assets/image/icons/setting-icon.png"; 
import loginBg from "../../../assets/image/webLogin/bg.jpg"; 
import langSelectIcon from "../../../assets/image/webLogin/tra.png"; 
import userName from "../../../assets/image/webLogin/account.png"; 
import password from "../../../assets/image/webLogin/password.png"; 
import helmet from "../../../assets/image/support/helmet.png"; 
import folder from "../../../assets/image/support/folder.png"; 
import serviceIcon from "../../../assets/image/support/potrait-service.png"; 
import userDefaultAvatar from "../../../assets/image/support/potrait-user.png"; 
import star from "../../../assets/image/support/star_hover-icon.png"; 
import supportChecked from "../../../assets/image/support/checked-icon.png"; 
import userInfoDefaultAvatar from "../../../assets/image/support/user-avatar.png"; 
import serviceInputIcon from "../../../assets/image/icons/service-input-icon.png"; 
import supportSearchIcon from "../../../assets/image/support/search.png"; 
import subscribeIcon from "../../../assets/image/icons/subscribeIcon-icon-blue.png"; 
import subscribeItemGoDetail from "../../../assets/image/icons/subscribeIcon-icon-go-detail.png"; 
import appleDeleteIcon from "../../../assets/image/icons/apple-delete.png"; 
import shortcutIcon from "../../../assets/image/icons/shortcut.png"; 
let $fillBtnVh = {
  'width' : '100%',
  'height' : '6.3vh',
  'line-height' : '6.3vh',
  'font-size' : '2.3vh'
}
let $onestoreSubscribeItemStyles = {
  'display' : 'flex',
  'flex-direction' : 'column',
  'justify-content' : 'space-between',
  'height' : '190px',
  'border-radius' : '10px',
  'padding' : '26px 17px',
  'box-sizing' : 'border-box',
  'margin-top' : '23px',
  'transition' : 'none',
  'opacity' : '1'
}
let $lightGreen = '#5fd193'
let $middleGreen = '#57ae67'
let $passportFunctionIconStyles = {
  'background-repeat' : 'no-repeat',
  'width' : '78px',
  'height' : '95px',
  'background-position' : 'center center',
  'background-size' : 'auto !important'
}
let $activeListItem = {
  'border-color' : $middleGreen,
  'color' : $middleGreen
}

  export default {
'vlink' : { 

 typeTheme :{ 
 'repaireAccountBtn' : { 
  'background-color' : '#5fd193'
 
}} 
}
,
'button' : { 
  commonTheme : {
  'font-size' : '32px',
  'height' : '60px',
  'line-height' : '60px',
  'color' : 'white',
  'background-color' : $lightGreen
  },
 typeTheme :{ 
 'repaireAccountApplyBtn' : { 
  'height' : '40px',
  'line-height' : '40px',
  'width' : '288px',
  'margin' : '50px auto 0',
  'font-size' : '18px',
  'color' : '#fff',
  'background-color' : '#5fd193'
 
},
 'repaireAccountQueryBtn' : { 
  'height' : '40px',
  'line-height' : '40px',
  'width' : '288px',
  'margin' : '50px auto 0',
  'font-size' : '18px',
  'color' : '#fff',
  'background-color' : '#5fd193'
 
},
 'markScoreMainClose' : { 
  'height' : '24px',
  'background-color' : 'transparent'
 
},
 'long' : { 
  'width' : '456px'
 
},
 'short' : { 
  'width' : '300px'
 
},
 'edit' : { 
  'height' : '80px'
 
},
 'fill' : { 
  'width' : '100%',
  'background-color' : $middleGreen
 
},
 'refresh' : { 
  'background-color' : $middleGreen,
  'height' : '72px'
 
},
 'selectResetPwd' : { 
  'width' : '200px',
  'height' : '50px',
  'line-height' : '50px',
  'border-radius' : '0',
  'font-size' : '18px',
  'background-color' : $middleGreen
 
},
 'selectPayType' : { 
  'width' : '230px',
  'height' : '60px',
  'line-height' : '60px',
  'color' : '#1c9554',
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOYAAAA9CAYAAAC5kxVXAAADH0lEQVR4nO3aT04TURzA8e8UMa6McWNcI/EKHsATuOYEnsAjyFmImLJywca48Q56B7XiBK3tcyEYJLS08+/9Zub7SUjYdPoIfPm9edNinhYA+8Br4DlwH2VSdPCK7bX5Hl2sf3v1VlXx1TPgFHhVFMWnYp4WT4GPwINaq1FN8aIcX5BQZ2UN/UxfgWfFPC3eAC+auaaqMcoYskd56biYp8U33L5mZJQxhIkS4KyYp0Vq/rrajFHGECpKACYtXVe3MsoY4kUJcKfFa2slo8wvy8nrxpyYnTPK/GJHCU7MDlX7dRpl0+JHCU7MjhhlDP2IEpyYHXDrGkN/ogTDbJlRxhDz5HUdt7KtMcoY+hclGGZLjDKGfkYJhtkCo4yhv1GC95gNM8r8+nXIs4oTszFGmd8wogQnZgN8RhnDcKIEJ2ZNRhnDsKIEw6zBKGMYXpTgVrYi7ydjGGaUYJgVGGUM/X4cchu3slsxyhiGHSUY5haMMobhRwmGuSGjjGEcUYL3mBswyvyGe8izihNzLaPMb3xRghNzBZ9RxjDOKMGJeQOjjGG8UYJhXmOUMYw7SnAre4X3kzGM5+R1HScmYJRRGOUlwzTKIIzyqpGHaZQxGOV1Iw7TKGMwypuM9PDHKPPz5HWdEU5Mo8zPKG8zoonpM8oYjHITI5mYRhmDUW5qBBMz3ta17feI+QdslNsYeJjxohxfkODJ6/YGvJU1yhiMsoqBhmmUMRhlVQMM0yhjMMo6BhamUcZglHUN6PDHKPPz5LUpA5mYRpmfUTap5xPTDw7EYJRN6/HENMoYjLINPZ2Ybl1jMMq29DBMo4zBk9c29Wwra5QxGGXbehSmUcZglF3oSZhGGYNRdmWSUvqeexHrGWV+BUbZnZTSj0lZlh9yL2Q1o8zPk9eulWX5fnIyPTlcLpez3Iv5X7X/0EbZNKPs2nK5nE2n08Odt8fHv57s77/b29t7tLu7+7goirt5l+YHB2Iwyi6llM7Ksjw9Ojp6eXBw8LkAHgL3ci9M0j/nE2AGLHOvRBLwt8XZzsU358DOxZe7EKl7CfgJfAF+/wHfp1NrfTUt/wAAAABJRU5ErkJggg==);'
 
},
 'selectInnerWay' : { 
  'background-image' : 'url(data:image/png;base64,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);'
 
},
 'switchProduct' : { 
  'background-image' : `url( ${whiteProductSwitchBtn})`,
  'width' : '56px',
  'height' : '56px',
  'background-color' : 'transparent',
  'border-radius' : '0'
 
},
 'reStore' : { 
  'background-color' : '#de6262'
 
},
 'swtichAccount' : { 
  'background-color' : 'transparent',
  'color' : '#57ae67',
  'height' : '50px',
  'line-height' : '18px',
  'font-size' : '15px'
 
},
 'lightShort' : { 
  'background' : '#57ae67',
  'height' : '72px',
  'line-height' : '72px',
  'font-size' : '20px'
 
},
 'closeBtn' : { 
  'height' : '24px',
  'width' : '24px',
  'font-size' : 'initial',
  'background-color' : 'transparent'
 
},
 'fillLightDialog' : { 
  'width' : '100%',
  'background-color' : '#57ae67'
 
},
 'fillLight' : { 
  'width' : '100%',
  'background-color' : '#57ae67'
 
},
 'fillLights' : { 
  'width' : '100%',
  'background-color' : '#57ae67'
 
},
 'fillLightVh' : { 
  ...$fillBtnVh
 
},
 'fillEmtyBorderVh' : { 
  ...$fillBtnVh,
  'background-color' : 'transparent',
  'color' : '#5fd193'
 
},
 'shortCancel' : { 
  'background-color' : '#949494',
  'box-sizing' : 'border-box',
  'border' : '1px solid #a7a7a7',
  'height' : '54px',
  'line-height' : '54px',
  'font-size' : '20px'
 
},
 'shortConfirm' : { 
  'background-color' : '#57ae67',
  'box-sizing' : 'border-box',
  'border' : '1px solid #76bc83',
  'height' : '54px',
  'line-height' : '54px',
  'font-size' : '20px'
 
},
 'logoutBtn' : { 
  'height' : '4vh',
  'line-height' : '4vh',
  'font-size' : '1.8vh',
  'background' : 'hsla(0,0%,100%,.6)',
  'color' : '#7a7a7a'
 
},
 'shortWidth' : { 
  'background-color' : '#9588e4'
 
},
 'grayShort' : { 
  'background' : '#ccc',
  'height' : '72px',
  'line-height' : '72px'
 
},
 'bankInvoiceBtn' : { 
  'width' : '90%',
  'background-color' : '#9fc9f5'
 
},
 'cancelSubscribe' : { 
  'width' : '100%',
  'height' : '64px',
  'line-height' : '64px',
  'border-radius' : '10px',
  'font-size' : '23.5px',
  'color' : '#fff',
  'background-color' : '#b4d7fb',
  'margin' : '78px auto 0'
 
}} 
}
,
'title' : { 
  commonTheme : {
  'color' : $middleGreen
  },
 typeTheme :{ 
 'payTitle' : { 
  'font-size' : ''
 
},
 'articleTtile' : { 
  'font-size' : '36px'
 
}} 
}
,
'headerContainer' : { 
  commonTheme : {
  'background' : '#f3f3f3'
  }}
,
'SelectGroup' : { 
  commonTheme : {
  'color' : '#57ae67',
  'border' : 'solid 1px #5fd193'
  },
 typeTheme :{ 
 'selectStoreInfo' : { 
  'width' : '100%',
  'box-sizing' : 'border-box',
  'display' : 'inline-block',
  'height' : '4.2vh',
  'border-radius' : '0',
  'padding' : '0 2vh',
  'background' : '#fff',
  'color' : '#666',
  'border-color' : 'rgb(169,169,169)',
  'margin-bottom' : '1.7vh'
 
}} 
}
,
'select' : { 
  commonTheme : {
  'color' : '#57ae67',
  'border' : 'solid 1px #5fd193'
  },
 typeTheme :{ 
 'selectLang' : { 
  'border' : '0',
  'color' : '#7a7a7a'
 
},
 'selectLangLogin' : { 
  'border' : '0',
  'color' : '#7a7a7a',
  'border-radius' : '4px'
 
},
 'selectStoreInfo' : { 
  'width' : '100%',
  'box-sizing' : 'border-box',
  'display' : 'inline-block',
  'height' : '4.2vh',
  'border-radius' : '0',
  'padding' : '0 2vh',
  'background' : '#fff',
  'color' : '#666',
  'border-color' : 'rgb(169,169,169)',
  'margin-bottom' : '1.7vh'
 
},
 'selectProductOrder' : { 
  'color' : '#666',
  'border-color' : 'rgb(169,169,169)',
  'height' : '4.2vh',
  'border-radius' : '0',
  'padding' : '0 2vh',
  'background' : '#fff'
 
}} 
}
,
'add' : { 
  commonTheme : {
  'background-image' : 'url(data:image/png;base64,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)'
  }}
,
'supportReplyInput' : { 
  commonTheme : {
  'height' : '80px',
  'line-height' : '80px',
  'vertical-align' : 'top'
  }}
,
'icon' : { 

 typeTheme :{ 
 'searchType' : { 
  'background-image' : `url( ${supportSearchIcon})`,
  'width' : '25px',
  'height' : '26px'
 
},
 'loginBtnLeft' : { 
  'display' : 'none'
 
},
 'loginBtnRight' : { 
  'display' : 'none'
 
},
 'loginBtnLeft2' : { 
  'display' : 'none'
 
},
 'loginBtnRight2' : { 
  'display' : 'none'
 
},
 'loginBoxLeftTop' : { 
  'display' : 'none'
 
},
 'loginBoxRightTop' : { 
  'display' : 'none'
 
},
 'loginBoxLeftBottom' : { 
  'display' : 'none'
 
},
 'loginBoxRightBottom' : { 
  'display' : 'none'
 
},
 'thirdPartNameIconLeft' : { 
  'display' : 'none'
 
},
 'thirdPartNameIconRight' : { 
  'display' : 'none'
 
},
 'resultBackBtnLeft' : { 
  'display' : 'none'
 
},
 'resultBackBtnRight' : { 
  'display' : 'none'
 
},
 'resultHistoryBtnLeft' : { 
  'display' : 'none'
 
},
 'resultHistoryBtnRight' : { 
  'display' : 'none'
 
},
 'supportReturnGameHelmet' : { 
  'display' : 'inline-block'
 
},
 'commonBtnLeft' : { 
  'display' : 'none'
 
},
 'commonBtnRight' : { 
  'display' : 'none'
 
},
 'createWorkBtnLeft' : { 
  'display' : 'none'
 
},
 'createWorkBtnRight' : { 
  'display' : 'none'
 
},
 'submitBtnCheck' : { 
  'display' : 'inline-block'
 
},
 'select' : { 
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQY043QMQrCQBCF4X9FvEFukH57G0t7LUUG0u8B9AT2c4JFvISVoNhPnxvkBtvEZgOLkpiBad7jm2KcmDrgChyYNzfg6ADEdAXcgc0f9AC20YfkhkRMK+AN1COoBdbRhw7AlY2Y1hlXX6jLqB2CRdnmYgekIk7AvkQ/MOMX0AB93ib68Jz5OBDTk5iex/rlhL1MHf4A3hMoYMjpP7EAAAAASUVORK5CYII=);',
  'width' : '14px',
  'height' : '8px'
 
},
 'serviceInput' : { 
  'background-image' : `url( ${serviceInputIcon})`,
  'width' : '20px',
  'height' : '12px'
 
},
 'quessionSelect' : { 
  'border-top-color' : $middleGreen
 
},
 'bindIcon' : { 
  'background-image' : `url( ${bindIcon})`,
  ...$passportFunctionIconStyles
 
},
 'userIcon' : { 
  'background-image' : `url( ${userIcon})`,
  ...$passportFunctionIconStyles
 
},
 'tokenIcon' : { 
  'background-image' : `url( ${tokenIcon})`,
  ...$passportFunctionIconStyles
 
},
 'dmaIcon' : { 
  'background-image' : `url( ${dmaIcon})`,
  ...$passportFunctionIconStyles
 
},
 'ellipsisIcon' : { 
  'background-image' : `url( ${ellipsisIcon})`,
  ...$passportFunctionIconStyles
 
},
 'officialPayIcon' : { 
  'background-image' : `url( ${officialPayIcon})`,
  ...$passportFunctionIconStyles
 
},
 'textIcon' : { 
  'background-image' : `url( ${textIcon})`,
  ...$passportFunctionIconStyles
 
},
 'accountFollowIcon' : { 
  'background-image' : `url( ${accountFollowIcon})`,
  ...$passportFunctionIconStyles
 
},
 'exchangeIcon' : { 
  'background-image' : `url( ${exchangeIcon})`,
  ...$passportFunctionIconStyles
 
},
 'rewardIcon' : { 
  'background-image' : `url( ${rewardIcon})`,
  ...$passportFunctionIconStyles
 
},
 'fundTermsIcon' : { 
  'background-image' : `url( ${fundTermsIcon})`,
  ...$passportFunctionIconStyles
 
},
 'survey' : { 
  'background-image' : `url( ${survey})`,
  ...$passportFunctionIconStyles
 
},
 'settingIcon' : { 
  'background-image' : `url( ${settingIcon})`,
  ...$passportFunctionIconStyles
 
},
 'deleteIcon' : { 
  'background-image' : `url( ${deleteIcon})`,
  ...$passportFunctionIconStyles
 
},
 'selectHili' : { 
  'background-image' : `url( ${showdetail})`,
  'background-repeat' : 'no-repeat',
  'width' : '11px',
  'height' : '18px'
 
},
 'selectvh' : { 
  'background-image' : `url( ${langSelectIcon})`,
  'background-repeat' : 'no-repeat',
  'background-size' : 'contain',
  'width' : '1.6vh',
  'height' : '1.2vh'
 
},
 'userName' : { 
  'background-image' : `url( ${userName})`,
  'width' : '2.1vh',
  'height' : '2.5vh',
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
},
 'password' : { 
  'background-image' : `url( ${password})`,
  'width' : '1.9vh',
  'height' : '2.4vh',
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
},
 'helmet' : { 
  'width' : '24px',
  'height' : '38px',
  'display' : 'inline-block',
  'background-image' : `url( ${helmet})`,
  'background-size' : 'contain',
  'vertical-align' : 'sub',
  'margin-right' : '10px'
 
},
 'folder' : { 
  'width' : '24px',
  'height' : '38px',
  'display' : 'inline-block',
  'background-size' : 'contain',
  'vertical-align' : 'sub',
  'margin-right' : '10px',
  'background-image' : `url( ${folder})`
 
},
 'serviceDefaultAvatar' : { 
  'background-image' : `url( ${serviceIcon})`
 
},
 'userDefaultAvatar' : { 
  'background-image' : `url( ${userDefaultAvatar})`
 
},
 'userInfoDefaultAvatar' : { 
  'background-image' : `url( ${userInfoDefaultAvatar})`
 
},
 'line' : { 
  'background-color' : '#5fd193'
 
},
 'custom' : { 
  'color' : '#5fd193'
 
},
 'storeBtnLeft' : { 
  'display' : 'none'
 
},
 'storeBtnRight' : { 
  'display' : 'none'
 
},
 'subscribeIcon' : { 
  'background-image' : `url( ${subscribeIcon})`,
  ...$passportFunctionIconStyles
 
},
 'subscribeItemGoDetail' : { 
  'display' : 'inline-black',
  'width' : '13px',
  'height' : '23px',
  'background-image' : `url( ${subscribeItemGoDetail})`
 
},
 'appleDeleteIcon' : { 
  'background-image' : `url( ${appleDeleteIcon})`,
  ...$passportFunctionIconStyles
 
},
 'shortcutIcon' : { 
  'background-image' : `url( ${shortcutIcon})`,
  ...$passportFunctionIconStyles
 
}} 
}
,
'block' : { 

 typeTheme :{ 
 'funtionListItem' : { 
  'line-height' : '95px'
 
},
 'webLogin' : { 
  'background-image' : `url( ${loginBg})`,
  'background-position' : 'top center',
  'background-color' : '#89dcaf'
 
},
 'maintainScoreImg' : { 
  'display' : 'block',
  'width' : '158px',
  'height' : '158px',
  'margin' : '80px auto 20px auto',
  'background-image' : `url( ${supportChecked})`,
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
},
 'onestoreSubscribePageContainer' : { 
  'position' : 'relative',
  'background' : '#fff',
  'padding' : '18px 24px'
 
},
 'subscribeManage' : { 
  'margin-bottom' : '45px'
 
},
 'subscribeManageDetail' : { 
  'margin-bottom' : '45px'
 
},
 'subscribeManageContent' : { 
  'min-height' : '92vh'
 
},
 'subscribeManageDetailContent' : { 
  'min-height' : '92vh'
 
},
 'onestoreSubscribePrivacy' : { 
  'display' : 'block',
  'text-align' : 'center',
  'font-size' : '22px',
  'color' : '#5d7c9d'
 
},
 'onestoreSubscribeDetailItem' : { 
  ...$onestoreSubscribeItemStyles,
  'height' : '142px',
  'background' : '#e9f4ff'
 
},
 'onestoreSubscribeTimeItem' : { 
  ...$onestoreSubscribeItemStyles,
  'padding' : '21px 17px',
  'height' : '102px',
  'background' : '#fff',
  'border' : '1px solid #dfdfdf'
 
},
 'onestoreSubscribeTimeItem-active' : { 
  ...$onestoreSubscribeItemStyles,
  'padding' : '21px 17px',
  'height' : '102px',
  'background' : '#fff',
  'border' : '1px solid #81acd9'
 
}} 
}
,
'list' : { 

 typeTheme :{ 
 'passportFunctionList' : { 
  'float' : 'left'
 
}} 
}
,
'mark' : { 

 typeTheme :{ 
 'amount' : { 
  'color' : '#de6263'
 
},
 'subscribeTitle' : { 
  'color' : '#414141',
  'font-size' : '28px',
  'font-weight' : 'bolder',
  'text-decoration' : 'none'
 
},
 'subscribeItemTitle' : { 
  'color' : '#787878',
  'font-size' : '23.6px',
  'font-weight' : 'bolder',
  'text-decoration' : 'none'
 
},
 'subscribeItemTitle-active' : { 
  'color' : '#414141'
 
},
 'subscribeItemContent' : { 
  'display' : 'block',
  'color' : '#787878',
  'font-size' : '22px',
  'text-decoration' : 'none',
  'line-height' : '25px',
  'margin-bottom' : '17px',
  'overflow' : 'hidden',
  'text-overflow' : 'ellipsis',
  'white-space' : 'nowrap'
 
},
 'subscribeItemContent-active' : { 
  'color' : '#333'
 
},
 'subscribeItemTime' : { 
  'text-align' : 'center',
  'height' : '32px',
  'line-height' : '32px',
  'color' : '#798189',
  'font-size' : '20px',
  'text-decoration' : 'none',
  'background-color' : '#c9ced2',
  'border-radius' : '32px',
  'padding' : '7px 10px'
 
},
 'subscribeItemTime-active' : { 
  'color' : '#5d7c9d',
  'background-color' : '#cadff4'
 
},
 'expireTips' : { 
  'display' : 'block',
  'color' : '#787878',
  'font-size' : '22px',
  'text-decoration' : 'none',
  'margin' : '23px 0'
 
},
 'onestoreSubscribeTip' : { 
  'display' : 'block',
  'height' : '25px',
  'color' : '#999',
  'font-size' : '22px',
  'text-decoration' : 'none',
  'margin' : '78px 0',
  'text-align' : 'center',
  'line-height' : '25px'
 
},
 'subscribeItemProduct' : { 
  'display' : 'block',
  'color' : '#333',
  'font-size' : '23.6px',
  'font-weight' : 'bolder',
  'text-decoration' : 'none',
  'line-height' : '25px',
  'margin-bottom' : '17px',
  'overflow' : 'hidden',
  'text-overflow' : 'ellipsis',
  'white-space' : 'nowrap'
 
},
 'subscribeItemDesc' : { 
  'color' : '#5d7c9d',
  'font-size' : '20px',
  'text-decoration' : 'none'
 
},
 'subscribeItemDetailTime' : { 
  'color' : '#999',
  'font-size' : '20.5px',
  'text-decoration' : 'none'
 
},
 'subscribeItemDetailTitle' : { 
  'color' : '#333',
  'font-size' : '23.6px',
  'text-decoration' : 'none'
 
},
 'subscribeItemDetailPrices1' : { 
  'color' : '#333',
  'font-size' : '23.6px',
  'text-decoration' : 'none'
 
},
 'subscribeItemDetailPrices2' : { 
  'display' : 'none'
 
},
 'subscribeDetailTip' : { 
  'display' : 'inline-block',
  'font-size' : '22px',
  'color' : '#999',
  'line-height' : '28px',
  'text-decoration' : 'none',
  'margin-bottom' : '20px'
 
}} 
}
,
'listItem' : { 

 typeTheme :{ 
 'active' : { 
  ...$activeListItem
 
},
 'selectItem' : { 
  'border' : '1px solid #5fd193'
 
},
 'functionItem' : { 
  'height' : '95px',
  'display' : 'flex',
  'align-items' : 'center'
 
},
 'accountSettingItem' : { 
  'height' : '95px',
  'display' : 'flex',
  'align-items' : 'center'
 
},
 'locationItem' : { 
  'height' : '80px'
 
},
 'productSelectOptions' : { 
  'text-align' : 'left'
 
},
 'paymentItem' : { 
  'height' : '80px'
 
}} 
}
,
'thirPartPay' : { 
  commonTheme : {
  'background-image' : `url( ${thirPartPayBg})`
  }}
,
'selectTriggerBtn' : { 

 typeTheme :{ 
 'amountSelect' : { 
  'float' : 'right'
 
},
 'bankSelect' : { 
  'color' : $middleGreen,
  'width' : '60%',
  'height' : '60px',
  'margin' : '0 auto',
  'text-align' : 'center',
  'padding' : '0 10px',
  'border' : `1px solid ${$lightGreen}`
 
}} 
}
,
'scoreStart' : { 

 typeTheme :{ 
 'active' : { 
  'background-image' : `url( ${star})`,
  'background-repeat' : 'no-repeat'
 
}} 
}
,
'blockClickable' : { 

 typeTheme :{ 
 'bankWayDetail' : { 
  'border' : `1px solid ${$middleGreen}`,
  'padding-right' : '30px',
  'flex-wrap' : 'wrap',
  'height' : 'auto'
 
},
 'onestoreSubscribeItem' : { 
  ...$onestoreSubscribeItemStyles,
  'background' : '#eaeef1'
 
},
 'onestoreSubscribeItem-active' : { 
  ...$onestoreSubscribeItemStyles,
  'background' : '#e9f4ff'
 
}} 
}
,
'typeCategory' : { 
  commonTheme : {
  'color' : $middleGreen
  }}
,
'bankText' : { 
  commonTheme : {
  'color' : $middleGreen
  }}
,
'bankTotal' : { 
  commonTheme : {
  'border-color' : '#57ae67'
  }}

}